import { AdditionalDiscount, DefaultDiscount } from '~/types/discount';
import api from '~/utils/api';
import { Pagination } from '~/types';

export const getAdditionalDiscounts = async (): Promise<
  Pagination<AdditionalDiscount>
> => {
  const { data } = await api.get<Pagination<AdditionalDiscount>>(
    '/desconto_adicional/',
  );

  return data;
};

export const saveAdditionalDiscount = async (
  id: number | null,
  discount: AdditionalDiscount,
): Promise<AdditionalDiscount> => {
  if (id) {
    return updateAdditionalDiscount(id, discount);
  }
  return createAdditionalDiscount(discount);
};

const updateAdditionalDiscount = async (
  id: number,
  discount: AdditionalDiscount,
): Promise<AdditionalDiscount> => {
  const { data } = await api.put<AdditionalDiscount>(
    `/desconto_adicional/${id}`,
    discount,
  );

  return data;
};

const createAdditionalDiscount = async (
  discount: AdditionalDiscount,
): Promise<AdditionalDiscount> => {
  const { data } = await api.post<AdditionalDiscount>(
    '/desconto_adicional/',
    discount,
  );

  return data;
};

export const getDefaultDiscounts = async (): Promise<
  Pagination<DefaultDiscount>
> => {
  const { data } = await api.get<Pagination<DefaultDiscount>>(
    '/desconto_padrao/',
  );

  return data;
};

export const saveDefaultDiscount = async (
  id: number | null,
  discount: DefaultDiscount,
): Promise<DefaultDiscount> => {
  if (id) {
    return updateDefaultDiscount(id, discount);
  }
  return createDefaultDiscount(discount);
};

const updateDefaultDiscount = async (
  id: number,
  discount: DefaultDiscount,
): Promise<DefaultDiscount> => {
  const { data } = await api.put<DefaultDiscount>(
    `/desconto_padrao/${id}`,
    discount,
  );

  return data;
};

const createDefaultDiscount = async (
  discount: DefaultDiscount,
): Promise<DefaultDiscount> => {
  const { data } = await api.post<DefaultDiscount>(
    '/desconto_padrao/',
    discount,
  );

  return data;
};
